var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5454",
    "data-name": "Group 5454",
    transform: "translate(-500 -400)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 50,
    height: 50,
    rx: 25,
    transform: "translate(500 400)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("g", {
    id: "call",
    transform: "translate(515 415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5426",
    "data-name": "Group 5426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67639",
    "data-name": "Path 67639",
    d: "M18.4,13.128a11.355,11.355,0,0,1-3.566-.568,1.63,1.63,0,0,0-1.585.334l-2.249,1.7A12.428,12.428,0,0,1,5.407,9.005l1.648-2.19a1.617,1.617,0,0,0,.4-1.638A11.373,11.373,0,0,1,6.883,1.6,1.607,1.607,0,0,0,5.278,0H1.6A1.607,1.607,0,0,0,0,1.6,18.416,18.416,0,0,0,18.4,20,1.607,1.607,0,0,0,20,18.4V14.733A1.607,1.607,0,0,0,18.4,13.128Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a1c72985d7c85655c5d8b19fcdd0fa66.svg";
export { ForwardRef as ReactComponent };